import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { CoursesPage } from './pages/CoursesPage';
import { CoachingPage } from './pages/CoachingPage';
import { AppComingSoonPage } from './pages/AppComingSoonPage';
import { TravelPage } from './pages/TravelPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="/courses" element={<CoursesPage data-id="element-10" />} data-id="element-9" />
            <Route path="/coaching" element={<CoachingPage data-id="element-12" />} data-id="element-11" />
            <Route path="/travel" element={<TravelPage data-id="element-14" />} data-id="element-13" />
            <Route path="/app" element={<AppComingSoonPage data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}